// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__UwFDp","right":"styles_right__J6H1Q"};